/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListAssignableAssetIdsResponseDto
 */
export interface ListAssignableAssetIdsResponseDto {
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof ListAssignableAssetIdsResponseDto
     */
    data: Array<Array<string>>;
}

/**
 * Check if a given object implements the ListAssignableAssetIdsResponseDto interface.
 */
export function instanceOfListAssignableAssetIdsResponseDto(value: object): value is ListAssignableAssetIdsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListAssignableAssetIdsResponseDtoFromJSON(json: any): ListAssignableAssetIdsResponseDto {
    return ListAssignableAssetIdsResponseDtoFromJSONTyped(json, false);
}

export function ListAssignableAssetIdsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssignableAssetIdsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function ListAssignableAssetIdsResponseDtoToJSON(json: any): ListAssignableAssetIdsResponseDto {
    return ListAssignableAssetIdsResponseDtoToJSONTyped(json, false);
}

export function ListAssignableAssetIdsResponseDtoToJSONTyped(value?: ListAssignableAssetIdsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

